import type { TimelineActiveStep } from '@/components/common/StateMachineTimeline';

export function timelineActiveStepKey(step: TimelineActiveStep): string {
  return `${step.stageKey}:${step.substepId ?? ''}`;
}
